import useWidth from '@components/Hooks/useWidth';
import DetailsIcon from '@components/v2/icons/Details';
import Badge from '@components/v2/ui/Badge/Badge';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { DetailsToggleAlert } from '../../objectScreen.types';

const ALERT_BADGE_SX = {
  '& .MuiBadge-badge': {
    padding: 0,
    minWidth: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
  },
};

interface DetailsToggleProps {
  isActive: boolean;
  disabled?: boolean;
  alert?: DetailsToggleAlert;
  testId?: string;
  onClick: () => void;
}

export const DetailsToggle = ({
  isActive,
  disabled,
  alert,
  testId,
  onClick,
}: DetailsToggleProps) => {
  const { translate } = useTranslation();
  const { smallWidth } = useWidth();

  if (smallWidth) {
    const iconToggle = (
      <IconButton
        icon={DetailsIcon}
        color="secondary"
        shape="round"
        isActive={isActive}
        disabled={disabled}
        ariaLabel={translate(LangEnum.GLOBAL_DETAILS_PANEL_TOGGLE)}
        testId={testId}
        onClick={onClick}
      />
    );

    return (
      <Tooltip TooltipContent={alert?.tooltip}>
        {alert ? (
          <Badge overlap="circular" badgeContent={alert.icon} sx={ALERT_BADGE_SX}>
            {iconToggle}
          </Badge>
        ) : (
          iconToggle
        )}
      </Tooltip>
    );
  }

  return (
    <Tooltip TooltipContent={alert?.tooltip}>
      <Button
        variant="contained"
        color="secondary"
        size="medium"
        isActive={isActive}
        disabled={disabled}
        testId={testId}
        onClick={onClick}
        startIcon={<Icon icon={DetailsIcon} />}
        endIcon={alert?.icon}
      >
        {translate(LangEnum.GLOBAL_DETAILS)}
      </Button>
    </Tooltip>
  );
};
